module.exports = __webpack_public_path__ + "img/12-bn.ac97240b.png";